<template>
  <div class="smart">
    <div class="container">
      <div class="row align-items-center">
        <!-- Left Image Section -->
        <div class="col-lg-5 col-md-5 img-smart">
          <img
            src="../../assets/img/home/kissing-grandma.png"
            alt="Kissing Grandma"
            class="main-img"
          />
        </div>
        <!-- Right Text and Form Section -->
        <div class="col-lg-7 col-md-7 text-smart">
          <div class="claim">
            <strong>Rediscover </strong>Life's Joys with HeartBeatFam!
          </div>
          <div class="spacer"></div>
          <div class="input-email">
            <div style="display: flex;">
              <input
                type="email"
                v-model="email"
                class="form-control"
                placeholder="Enter Email For Early Access"
              />
              <span class="error">{{ error }}</span>
              <button
                class="btn btn-success"
                @click="handleEarlyAccessButtonClick"
              >
                Free guide
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClaimYourCorner",
  data() {
    return {
      email: "",
      error: ""
    };
  },
  methods: {
    handleEarlyAccessButtonClick() {
      this.error = "";
      if (!this.validateEmail(this.email)) {
        this.error = "Please Enter a valid email!";
        return;
      }
      this.$emit("applied", this.email);
      this.email = "";
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
};
</script>

<style lang="scss" scoped>
.smart {
  background: url("../../assets/img/home/claim-your-corner-bg.png") no-repeat
    center center;
  background-size: cover;
  position: relative;
  width: 100vw;
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 50px 0;
  padding-bottom: 0;
}

.img-smart {
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-img {
  width: auto;
  max-width: 900px;
  height: auto;
  object-fit: contain;
}

.text-smart {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Moves text higher */
  align-items: flex-start;
  // margin-top: -30px; /* Adjust this to control how high the text goes */
}

.claim {
  font-family: "Lato";
  font-style: normal;
  font-weight: 900;
  font-size: 64px;
  line-height: 65px;
  color: #ffffff;
  margin-bottom: 30px;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.spacer {
  height: 20vh; // This creates a space between the heading and description
}

.input-email {
  display: flex;
  justify-content: flex-end; /* Aligns input and button to the right */
  align-items: center;
  column-gap: 8px;
  width: 100%;
  font-family: "Lato";
}

.form-control {
  padding: 12px 27px;
  height: 40px;
  border-radius: 20px;
  // border: 1px solid #fff;
  background-color: #a9f5c3;
  color: #fff;
  margin-right: 10px; /* Add margin between input and button */
  &:focus {
    outline: none;
    border-color: #fff;
  }
  &::placeholder {
    font-size: 15px;
    color: #8d57e6;
  }
}

.error {
  display: inline-block;
  margin-bottom: 6px;
  font-size: 12px;
  color: #fff;
}

.btn-success {
  background: #57aae6;
  border-radius: 32px;
  height: 40px;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  padding: 10px 20px;
  cursor: pointer;
  min-width: fit-content;
}

@media (max-width: 768px) {
  .smart {
    padding-left: 0;
    padding-right: 0;
    background-size: contain;
    padding-bottom: 120px;
    min-height: auto;
    background-color: #9666ff;
  }

  .main-img {
    max-width: 100%;
    height: auto;
  }

  .img-smart{
    padding: 0;
  }

  .claim {
    font-size: 36px;
    line-height: 1.2;
    margin-bottom: 20px;
  }

  .input-email {
    flex-direction: column; /* Stack input and button on mobile */
    align-items: flex-end; /* Align input and button to the right on mobile */
    gap: 10px;
  }

  .btn-success {
    width: 100%; /* Full width button on mobile */
  }

  .spacer {
    display: none; // Hides the spacer on mobile view to reduce unnecessary space
  }
}
</style>
